module.exports = __webpack_public_path__ + "img/undefined.0f439bf4.png";